
import state from './../../zviz2/zviz/state';
import Group from './../../zviz2/zviz/components/group';
import {Blueprint as NavigationBlueprint} from './navigation';
import {Blueprint as FilterBlueprint} from './filters';
import {extend, cloneObject} from './../../zviz2/zviz/functions';
//import {LifeCycle} from './../zviz2/zviz/cycle';



let Blueprint = extend({
    properties: {  },
    events: {  },
    children: [
        extend({
            properties: {
                style: {
                    backgroundColor: '#1e2dbe',
                    position: 'relative'
                }
            },
            children: [ cloneObject(NavigationBlueprint) ]
        }, Group),

        extend({
            properties: {
                style: {
                    backgroundColor: '#f2ece7',
                    marginTop: '5px',
                    position: 'relative'
                }
            },
            children: [ cloneObject(FilterBlueprint) ]
        }, Group)

    ]
}, Group);


export default Blueprint;
export {GroupController, Blueprint};
